import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { MfaService } from '../../../services/mfa/mfa.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lib-mfa-login',
  templateUrl: './mfa-login.component.html',
  styleUrl: './mfa-login.component.scss',
  standalone: false
})
export class MfaLoginComponent implements OnInit {
  @Input() mfaState: 'setup' | 'code' | null;

  qrCodeImage: string;
  code: string;
  invalidMfaCode = false;
  invalidSetupCode = false;

  public form: FormGroup;

  constructor(
    private mfaService: MfaService,
    private authService: AuthService,
    protected formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    if (this.mfaState === 'setup') {
      this.initMfaSetup();
    }

    this.authService.getIsBadAuth().subscribe(bad => {
      this.invalidMfaCode = bad;
    });

    this.form = this.formBuilder.group({
      deviceName: this.formBuilder.control('', Validators.required),
      code: this.formBuilder.control('', [Validators.required, Validators.maxLength(6)])
    })
  }

  initMfaSetup() {
    this.mfaService.initiateSetup().subscribe(resp => {
      this.qrCodeImage = resp.qrCodeImage;
    });
  }

  submitSetup() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const rawFormData = this.form.getRawValue()
    this.code = rawFormData.code;
    this.mfaService.completeSetup(rawFormData.code, rawFormData.deviceName).subscribe({
      next: () => {
        this.submit();
      },
      error: () => {
        this.invalidSetupCode = true;
      }
    });
  }

  submit() {
    if (!this.code) {
      return;
    }

    this.authService.loginUser('', '', false, this.code);
  }

  cancel() {
    this.authService.logout();
  }
}
